module.exports = __webpack_public_path__ + "img/img_mail_2.516957fd.png";